enum PublicNavigationLocations {
  HOME = "HOME",
  FIRST_LOGIN_RESET_PASSWORD = "FIRST_LOGIN_RESET_PASSWORD",
}

export default PublicNavigationLocations;